import { render, staticRenderFns } from "./TransactionNotesEditor.yaml?vue&type=template&id=dbf36692&component"
import script from "./TransactionNotesEditor.yaml?vue&type=script&lang=ts&component"
export * from "./TransactionNotesEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports